const partnerPaymentFields = [
  "email",
  "stateId",
  "countryAlpha2",
  "locality",
  "apartment",
  "address",
  "name",
  "countryId",
  "headsetType",
  "postal",
  "deliveryMethod",
  "voucher",
  "plan_id",
  "headset_purchase_token",
  "user_id",
  "phoneNumber",
  "itemType",
  "token",
  "promoApplied",
  "promoCode",
  "category_id",
];

const partnerFormState = {
  email: "",
  stateId: "",
  countryAlpha2: "",
  locality: "",
  apartment: "",
  address: "",
  name: "",
  countryId: "",
  postal: "",
  deliveryMethod: "",
  voucher: "",
  plan_id: "",
  headset_purchase_token: "",
  headsetType: "regular",
  phoneNumber: null,
  itemType: "Plan",
  token: "",
  promoApplied: "",
  promoCode: "",
  category_id: -1,
};

export { partnerPaymentFields, partnerFormState };
